export default "__VITE_ASSET__DytlfVDq__"